import React from "react";
import { observer } from "mobx-react";
import UiMeet3dLeadIndexPage from "~/modules/UiMeet3d/app/UiMeet3dLeadIndexPage";
import "../styles/TourIndexHeader.less";
import "../styles/SidePage.less";
// Moving the styles of the LayoutWrapper here to avoid getting the wrong variables
import "../styles/TourLayout.less";

const PanelUiMeet3dLeadIndexPage = observer(props => <UiMeet3dLeadIndexPage {...props} />);

export default PanelUiMeet3dLeadIndexPage;
